import { ICollection } from "services/types";
import { BackButton, MoreButton, PrivateTick, TrashButton } from "../buttons";

import "./CollectionHeader.scss";

export const CollectionHeader = (props: {
  collection: ICollection | undefined;
  backLink: string;
  editable: boolean;
  manage: boolean;
  more: () => void;
  trash: () => void;
}): JSX.Element => {
  const isManage = !!props.manage;
  const isEdit = props.editable && !props.manage;

  return (
    <div className="collectionHeader">
      <BackButton
        link={props.backLink}
      />

      {!isManage && <h2>
        {props?.collection?.folderName ?? "An unnamed"} collection
        {!props?.collection?.published && <PrivateTick />}
      </h2>}

      {isManage && <h2>Manage collection</h2>}

      {isEdit && <MoreButton
        id="collectionMoreButton"
        onClick={props.more}
      />}

      {isManage && <TrashButton
        onClick={props.trash}
      />}
    </div>
  );
};
